import { render, staticRenderFns } from "./seurantakeskustelut-container.vue?vue&type=template&id=bd76552e&scoped=true&"
import script from "./seurantakeskustelut-container.vue?vue&type=script&lang=ts&"
export * from "./seurantakeskustelut-container.vue?vue&type=script&lang=ts&"
import style0 from "./seurantakeskustelut-container.vue?vue&type=style&index=0&id=bd76552e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd76552e",
  null
  
)

export default component.exports